import {createApp, reactive} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/table-header.css'
import './styles/rounded-controls.css'
import './styles/desktop-layout.css'
import App from './App.vue'
import router from './router'
import store from './store'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import i18n from './i18n'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$fileUrl = 'https://sfotrucking.com/file/'

app.config.globalProperties.$buttonList = []

const savedData = localStorage.getItem('menu');
const parsedData = savedData ? JSON.parse(savedData) : {};

const sideBarState = reactive({
    data: parsedData
});

app.config.globalProperties.$sideBar = sideBarState;


app.use(store).use(ElementPlus).use(router).use(i18n).mount('#app')
